import { useCouponUsageQuery } from '~/lib/Queries';
import Loading from '~/components/Loading';
import EventDetailsPanel from '~/components/calendar/EventDetailsPanel';
import { useState } from 'react';
import EditGrantPanel from "~/components/packages/EditGrantPanel";

const CouponUsageRow = ({ use, isFirst, onClick }) => {
    console.log('use=', use)

    let name = use.object?.event_type?.name || use.object?.package?.name;

    return (
        <div
            className={`flex py-3 cursor-pointer ${!isFirst ? 'border-t' : ''}`}
            onClick={onClick}
        >
            <div className="flex-1">{use.client?.name}</div>
            <div className="flex-1">{name}</div>
            <div className="flex-1">{use.code?.code}</div>
        </div>
    );
};

const CouponClientUsage = ({ couponId }) => {
    const { data, isLoading } = useCouponUsageQuery(couponId);
    const usage = data?.usage || [];
    const [selectedObject, setSelectedObject] = useState(null);

    return (
        <div>
            <div className="flex max-w-2xl pl-6">
                <div className="flex-1 column-label">Client</div>
                <div className="flex-1 column-label">Used On</div>
                <div className="flex-1 column-label">Code</div>
            </div>
            <div className="panel pl-6">
                {isLoading && <Loading className="py-3" />}
                {!isLoading && usage.length === 0 && (
                    <div className="py-3">No clients have used this yet</div>
                )}
                {usage.map((use, idx) => (
                    <CouponUsageRow
                        use={use}
                        key={use.id}
                        isFirst={idx === 0}
                        onClick={() => setSelectedObject(use.object)}
                    />
                ))}
            </div>
            <EventDetailsPanel
                isOpen={!!selectedObject && !!selectedObject.event_type}
                onClose={() => setSelectedObject(null)}
                event={!!selectedObject?.event_type && selectedObject}
            />
            <EditGrantPanel
                onClose={() => setSelectedObject(null)}
                isOpen={!!selectedObject && !!selectedObject.package}
                grant={!!selectedObject?.package && selectedObject}
            />
        </div>
    );
};

export default CouponClientUsage;
